import { render, staticRenderFns } from "./PCCRequestTable.vue?vue&type=template&id=39d2b518&"
import script from "./PCCRequestTable.vue?vue&type=script&lang=js&"
export * from "./PCCRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./PCCRequestTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports